"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    schema: function() {
        return schema;
    },
    schemaMap: function() {
        return schemaMap;
    }
});
var _sdkDeviceState = require("./external/SdkDeviceState");
var _schemaUtils = require("./schemaUtils");
var schema = {
    "parameters": [
        {
            "name": "uuid",
            "unit": "string",
            "description": "The unique identifier of the axis."
        },
        {
            "name": "controllerId",
            "unit": "string",
            "description": "The unique identifier of the controller that contains the axis."
        },
        {
            "name": "friendlyName",
            "unit": "string",
            "description": "The friendly name of the axis."
        },
        {
            "name": "device",
            "unit": "ioExpander",
            "format": "oneOf",
            "values": _sdkDeviceState.SdkDeviceIds,
            "default": 1,
            "description": "The device identifier."
        },
        {
            "name": "pushOutPin",
            "unit": "ioExpander",
            "format": "oneOf",
            "values": _sdkDeviceState.SdkDevicePins,
            "default": 1,
            "description": "The output pin index for the push valve."
        },
        {
            "name": "pushInPin",
            "unit": "ioExpander",
            "format": "oneOf",
            "values": _sdkDeviceState.SdkDevicePins.concat([
                null
            ]),
            "default": null,
            "description": "The input pin index for the push valve reedswitch."
        },
        {
            "name": "pullOutPin",
            "unit": "ioExpander",
            "format": "oneOf",
            "values": _sdkDeviceState.SdkDevicePins,
            "default": 0,
            "description": "The output pin index for the pull valve."
        },
        {
            "name": "pullInPin",
            "unit": "ioExpander",
            "format": "oneOf",
            "values": _sdkDeviceState.SdkDevicePins.concat([
                null
            ]),
            "default": null,
            "description": "The input pin index for the pull valve reedswitch."
        },
        {
            "name": "axisType",
            "unit": "string",
            "format": "oneOf",
            "values": [
                "pneumatic",
                "pneumatic_bag_gripper",
                "ac_motor_with_vfd"
            ],
            "default": "pneumatic",
            "description": "The actuator type of the axis."
        }
    ]
};
var parameterMap = (0, _schemaUtils.generateParameterMapFromArray)(schema.parameters);
var schemaMap = {
    parameters: parameterMap
};
